// extracted by mini-css-extract-plugin
export default {"replies":"tweet-replies_replies__qEhxP","link":"tweet-replies_link__hCiY+","text":"tweet-replies_text__0h3yr"};